import { SetVideoPlayerErrorPayload } from '../mutations/setVideoPlayerError';

/**
 * Query parameters related to the initialization of video page
 */
export interface VideoInitializationQueryParams {
  hosted?: boolean;
}

const booleanMap: Record<string, boolean | undefined> = {
  true: true,
  false: false,
};
const normalizeBoolean = <T extends [string, unknown]>(entry: T): T => {
  const [k, v] = entry;
  if (typeof v !== 'string') return entry;

  const normalizedBoolean = booleanMap[v.toLowerCase()];
  if (normalizedBoolean === undefined) return entry;
  return [k, normalizedBoolean] as T;
};

export const getQueryParams = (): VideoInitializationQueryParams => {
  const url = new URL(location.href);

  return Object.fromEntries(
    [...url.searchParams.entries()]
      .map(normalizeBoolean)
    ,
  );
};

export const assertNotNull = <T>(value: T): NonNullable<T> => {
  if (value == null) throw new Error('Null value is not expected at this point');
  return value as NonNullable<T>;
};

export const createPlayerErrorWithIssuer = (issuer?: SetVideoPlayerErrorPayload['issuer']) =>
  (payload: SetVideoPlayerErrorPayload | null): SetVideoPlayerErrorPayload => {
    if (payload == null) {
      return {
        error: null,
        issuer,
      };
    }
    return {
      issuer,
      ...payload,
    };
  }
;
